import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import BaseFooter from '@layout/Footer/BaseFooter';
import Header from './Header';
import AppContainer from '../Components/AppContainer';
import LayoutContainer from '../Components/Container';

const Container = styled(LayoutContainer)`
  min-width: 0px;
  background-color: var(--color-base-1);
  ${mediaQuery.uptoMobile} {
    width: 100vw;
    overflow-x: hidden;
  }
`;
const CommunityAppContainer = styled(AppContainer)`
  width: 1366px;
  grid-row-gap: 0;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding-left: ${Spacings.SPACING_4B};
  }
`;

const CommunityPageLayout = ({ children, className }) => {
  return (
    <Container className={className}>
      <Header />
      <CommunityAppContainer $tabletWidth="728px">
        {children}
      </CommunityAppContainer>
      <BaseFooter display noFooter={false} />
    </Container>
  );
};
export default CommunityPageLayout;
